import BoxedTierSelector from "../../../component/vehicle-form/BoxedTierSelector";
import { pick } from "../../../util/lodash/pick";
import styles from "./tire-size-calculator.module.scss";

function TireSizeCalculator(props: any) {
  const { handleSizeSelect, calculateSize } = props;
  return (
    <div className={styles.boxed_tier_selector_container}>
      <BoxedTierSelector
        autoScroll={false}
        handleSizeSelect={handleSizeSelect}
        calculateSize={calculateSize}
        {...pick(props, ["defaultMake", "defaultModel", "defaultYear", "selectionOrder", "years"])}
      />
    </div>
  );
}

export default TireSizeCalculator;
